import styled from 'styled-components';
export default styled.footer `
  width: 100%;
`;
//# sourceMappingURL=Footer.js.map